


/** BELOW SCRIPT IS TO FORCE-UPDATE INVENTORY STATUS OF A PRODUCT, TO AVOID TAGGING THE SOLD OUT ITEMS AS AVAILABLE */


function removeZapietDisable() {
    const styles = document.querySelector('#zapietDisable');
    if (styles) styles.remove();
}

function getFromSessionStorage(key) {
    const storeUrl = window.Shopify.shop;
    const value = sessionStorage.getItem(storeUrl + '.' + key);
    if (value) {
        try { return JSON.parse(value); } catch (e) { return value; }
    }
    return null;
}

function isVariantDateRestricted(restrictions, variantId, selectedDate) {
    if (!restrictions) return false;

    const restriction = restrictions.find(
        (restriction) => String(restriction.variant_id) === String(variantId)
    );
    if (!restriction) return false;

    if (restriction.restriction_type === 'allow') {
        return !restriction.restricted_dates.includes(selectedDate);
    }

    return restriction.restricted_dates.includes(selectedDate);
}

function updateProductAvailability() {
    removeZapietDisable();

    const selectedRestaurant =
        window.ZapietEats?.getSelectedRestaurant?.() ??
        getFromSessionStorage('selectedLocation');

    const selectedMenu =
        window.ZapietEats?.getSelectedMenu?.() ??
        getFromSessionStorage('selectedMenu');

    const variantMetafields = window.ZapietWidgetConfig?.variant_metafields;

    if (!selectedRestaurant || !selectedMenu || !variantMetafields) {
        console.warn("Zapiet Eats: Required data not fully loaded.");
        return;
    }

    // ✅ FIXED: Use Zapiet's REAL inventory date
    const inventoryDateObj = window.ZapietEats.getLocationInventoryDate?.();
    if (!inventoryDateObj) {
        console.warn("Zapiet Eats: Inventory date not ready.");
        return;
    }

    const selectedDate = inventoryDateObj.toISODate();

    const restaurantId = selectedRestaurant.id;
    const menuId = selectedMenu.id;
    const deliveryOption =
        window.ZapietEats.getDeliveryOption?.() === "pickup"
            ? "store_pickup"
            : "local_delivery";

    const restrictions =
        selectedMenu?.config?.[deliveryOption]?.product_date_restrictions || [];

    // Collect variant IDs from menu
    const menuVariantIds = [];
    selectedMenu?.menu_sections?.forEach((section) => {
        section?.menu_section_items?.forEach((item) => {
            if (item?.product?.variant_id)
                menuVariantIds.push(String(item.product.variant_id));
        });
    });

    // MAIN LOOP — evaluate each card
    document.querySelectorAll('.t4s-product').forEach((card) => {
        const optionsStr = card.getAttribute("data-product-options");
        if (!optionsStr) return;

        let productData;
        try {
            productData = JSON.parse(optionsStr);
        } catch (e) {
            console.error("Invalid JSON in data-product-options", e);
            return;
        }

        const variants =
            productData.Variants?.map((v) => v.id) ||
            [productData.VariantFirstID].filter(Boolean);

        if (variants.length === 0) return;

        const idsToCheck = variants.map(String);

        // NOT IN MENU CHECK
        const allNotInMenu = idsToCheck.every((id) => !menuVariantIds.includes(id));

        let badge = card.querySelector('.zapiet-badge');
        if (!badge) {
            badge = document.createElement("div");
            badge.className = "zapiet-badge";
            card.prepend(badge);
        }

        const addToCartBtn = card.querySelector(
            "form[action*='/cart'] button[type='submit']"
        );
        if (addToCartBtn && !addToCartBtn.hasAttribute("data-original-label")) {
            addToCartBtn.setAttribute(
                "data-original-label",
                addToCartBtn.innerText.trim()
            );
        }

        if (allNotInMenu) {
            badge.textContent = "NOT IN MENU";
            badge.style.display = "block";
            badge.style.backgroundColor = "#646464";
            badge.style.color = "#fff";
            if (addToCartBtn) {
                addToCartBtn.disabled = true;
                addToCartBtn.innerText = "UNAVAILABLE";
                addToCartBtn.classList.add("disabled");
            }
            return;
        }

        // Check sold-out & restricted status
        const soldOutStatuses = [];
        const restrictedStatuses = [];
        let anyAvailable = false;
        let anySoldOrRest = false;

        idsToCheck.forEach((variantId) => {
            const metafields = variantMetafields[variantId] || {};
            const key = `limits.${restaurantId}.${menuId}.${selectedDate}`;
            const limitData = metafields[key];

            const remaining = limitData?.remaining;
            const limit = limitData?.limit;
            const effectiveRemaining = typeof remaining === "number"
                ? remaining
                : typeof limit === "number"
                ? limit
                : null;

         //   const isSoldOut = effectiveRemaining !== null && effectiveRemaining <= 0;
        //By Mario -  Treat NULL / missing limits as SOLD OUT (safer bakery logic)
          const isSoldOut = effectiveRemaining === null || effectiveRemaining <= 0;


         const isRestricted = isVariantDateRestricted(restrictions, variantId, selectedDate);

            soldOutStatuses.push(isSoldOut);
            restrictedStatuses.push(isRestricted);

            if (!isSoldOut && !isRestricted) anyAvailable = true;
            if (isSoldOut || isRestricted) anySoldOrRest = true;
        });

        const allSoldOut = soldOutStatuses.every(Boolean);
        const unavailable =
            soldOutStatuses.filter(Boolean).length +
            restrictedStatuses.filter(Boolean).length === idsToCheck.length;

        const partiallyAvailable = anyAvailable && anySoldOrRest;

        // BADGE + BUTTON LOGIC
        if (allSoldOut) {
            badge.textContent = "SOLD OUT";
            badge.style.display = "block";
            badge.style.backgroundColor = "#d32f2f";
            badge.style.color = "#fff";
            if (addToCartBtn) {
                addToCartBtn.disabled = true;
                addToCartBtn.innerText = "UNAVAILABLE";
                addToCartBtn.classList.add("disabled");
            }
        } else if (unavailable) {
            badge.textContent = "UNAVAILABLE";
            badge.style.display = "block";
            badge.style.backgroundColor = "#9e9e9e";
            badge.style.color = "#fff";
            if (addToCartBtn) {
                addToCartBtn.disabled = true;
                addToCartBtn.innerText = "UNAVAILABLE";
                addToCartBtn.classList.add("disabled");
            }
        } else if (partiallyAvailable) {
            badge.textContent = "PARTIALLY AVAILABLE";
            badge.style.display = "block";
            badge.style.backgroundColor = "#ffc107";
            badge.style.color = "#000";
            if (addToCartBtn) {
                addToCartBtn.disabled = false;
                addToCartBtn.innerText =
                    addToCartBtn.getAttribute("data-original-label");
                addToCartBtn.classList.remove("disabled");
            }
        } else {
            badge.textContent = "AVAILABLE";
            badge.style.display = "block";
            badge.style.backgroundColor = "#388e3c";
            badge.style.color = "#fff";
            if (addToCartBtn) {
                addToCartBtn.disabled = false;
                addToCartBtn.innerText =
                    addToCartBtn.getAttribute("data-original-label");
                addToCartBtn.classList.remove("disabled");
            }
        }
    });
}

// SAFE MutationObserver — no infinite DOM recursion
document.addEventListener("zapieteats:ready", () => {

    requestAnimationFrame(updateProductAvailability);

    let forceEnd = Date.now() + 2000;
    const forceInterval = setInterval(() => {
        updateProductAvailability();
        if (Date.now() > forceEnd) clearInterval(forceInterval);
    }, 200);

    // Badge styles
    const zapietStyles = document.createElement("style");
    zapietStyles.innerHTML = `
        .zapiet-badge {
            position: absolute;
            top: 5px;
            left: 20px;
            padding: 4px 4px;
            border-radius: 4px;
            font-size: 9px;
            font-weight: bold;
            color: #fff;
            pointer-events:none;
            box-shadow: 0 0 5px rgba(0,0,0,0.3);
        }
    `;
    document.head.appendChild(zapietStyles);

    // SAFELY OBSERVE ONLY PDP AREA
    const targetNode = document.querySelector(".product-form, .t4s-product, #MainContent") || document.body;
    const config = { childList: true, subtree: false };

    const observer = new MutationObserver(() => {
        observer.disconnect();            // prevent recursion
        updateProductAvailability();
        observer.observe(targetNode, config);
    });

    observer.observe(targetNode, config);

    document.addEventListener("t4s:ajaxComplete", updateProductAvailability);
    document.addEventListener("content:loaded", updateProductAvailability);
});

